import { TrModalsModule } from './modals/modals.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatListModule } from '@angular/material/list';
import { PrintService } from './print.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip'; 
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import {MatMenuModule} from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio'
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatIconModule} from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { AuthService } from './service/auth-service';
import { LoginComponent } from './login/login.component';
import { DeliveryOptionComponent } from './delivery-option/delivery-option.component';
import { AuthGuardService } from './service/auth-guard-service';
import { QuoteService } from './test/quote.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TrTableModule } from './table/tr-table.module';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireFunctionsModule, FUNCTIONS_ORIGIN } from '@angular/fire/functions';
import { HttpClientModule } from '@angular/common/http';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import {NgxMaskModule} from 'ngx-mask-2'
import { TrDateModule } from './pipes/tr-date.module';
import { TrListPipeModule } from './pipes/tr-list.module';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { QuoteComponent } from './quote/quote.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from "@angular/material/card"
import { AngularFireAuthModule } from '@angular/fire/auth';
import { CustomerComponent } from './customer/customer.component';
import { ProductComponent } from './product/product.component';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { ProductDao } from './test/product.dao';
// import { ReportComponent } from './report/report.component';
import { PrintLayoutComponent } from './print-layout/print-layout.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { NavigationComponent } from './navigation/navigation.component';
import { ShowCustomerComponent } from './customer/show-customer/show-customer.component';
import { EditCustomerComponent } from './customer/edit-customer/edit-customer.component';
import { EditDeliveryOptionComponent } from './delivery-option/edit-delivery-option/edit-delivery-option.component';
import { EditProductComponent } from './product/edit-product/edit-product.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    QuoteComponent,
    CustomerComponent,
    ProductComponent,
    DeliveryOptionComponent,
   // ReportComponent,
    PrintLayoutComponent,
    InvoiceComponent,
    NavigationComponent,
    ShowCustomerComponent,
    EditCustomerComponent,
    EditDeliveryOptionComponent,
    EditProductComponent,
    ConfirmationDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
    TrTableModule,
    TrDateModule,
    MatDialogModule,
    MatCardModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatInputModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatListModule,
    MatSelectModule,
    MatToolbarModule,
    
    MatTooltipModule,
    MatFormFieldModule,
    MatRadioModule,
    MatDatepickerModule,
    TrListPipeModule,
    MatIconModule,
    MatCheckboxModule,
    MatNativeDateModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    AngularFireAuthModule,
    PdfViewerModule,
    TrModalsModule
  ],
  providers: [
    AuthGuardService, AuthService, QuoteService,ProductDao, PrintService,
    // { provide: FUNCTIONS_ORIGIN, useValue: "http://localhost:5001" },
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    EditCustomerComponent,
    EditDeliveryOptionComponent,
    EditProductComponent,
    ConfirmationDialogComponent,
  ]
})
export class AppModule { }
